import bold from '../fonts/Toyota-Bold/Toyota-Bold';
import colors from './colors';

const defaultTheme = {
  default: {
    ...colors,
    Fonts: {
      bold,
    },
  },
};

export default defaultTheme;
